import { createSelector } from 'reselect';
import { scienceRewardsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const scienceRewardsYearsSelector = createSelector([scienceRewardsSelector], (scienceRewards) =>
  extractDatesFromNestedItems(
    [scienceRewards.content],
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);
